// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_bV9","cls2":"CreateSocialItemModal-cls2_HfY CreateSocialItemModal-cls1_bV9"};